import { Divider, Grid, Paper } from "@material-ui/core";
import { capitalize } from "lodash";
import React from "react";
import { formatCurrency, formatDate } from "../../../../../../utils/formatters";
import { useQueryContext } from "../../../context";
import BackButton from "../elements/buttons/back";
import DetailsGrid from "../elements/details-grid";

const PrecatorioArea = ({ precatorio }) => {
  const { backToTable } = useQueryContext();
  const { credores } = precatorio;

  const columns = [
    {
      label: "Número do precatório / UF de origem",
      field: "numero",
      valueGetter: ({ numero, ufSigla }) => `${numero} / ${ufSigla}`,
      valueFormatter: (value) => <b>{value}</b>,
    },
    {
      label: "Tribunal",
      field: "tribunalAcronimo",
    },
    {
      label: "Valor de face",
      field: "valorEmCentavos",
      valueFormatter: formatCurrency,
    },
    {
      label: "Data base",
      field: "dataBase",
      valueFormatter: formatDate,
    },
    {
      label: "Valor LOA",
      field: "loaValorEmCentavos",
      valueFormatter: formatCurrency,
    },
    {
      label: "Atualizado até",
      field: "loaDataBase",
      valueFormatter: formatDate,
    },
    {
      label: "Data de expedição",
      field: "expedidoEm",
      valueFormatter: formatDate,
    },
    {
      label: "Natureza",
      field: "natureza",
      valueFormatter: capitalize,
    },
    {
      label: "Ente devedor",
      field: "devedorNome",
    },
    {
      label: "Ano de vencimento",
      field: "anoVencimento",
    },
    {
      label: "Número do ofício requisitório",
      field: "numeroRequisitorioFormatado",
    },
    {
      label: "Vara de origem",
      field: "varaUnidade.label",
    },
    {
      label: "Ordem cronológica",
      field: "ordemPagamentoEnte",
      valueFormatter: new Intl.NumberFormat("pt-BR", {
        maximumSignificantDigits: 10,
      }).format,
    },
    {
      label: "Número do processo originário",
      field: "processoOrigem.numero",
    },
  ];

  if (credores.length === 1) {
    columns.push({
      label: "Nº de meses do RRA",
      field: "credores[0].tributo.totalMesesRra",
    });
  }

  return (
    <Paper elevation={5} style={{ marginBottom: "24px" }}>
      <Grid style={{ padding: "0 24px 16px" }} container>
        <Grid item xs={12}>
          <div className="qd-buttons">
            <BackButton disabled={false} backToTable={backToTable} />
          </div>

          <Divider className="mb-30" />
          <h4 className="qd-area-title">DADOS DO PRECATÓRIO</h4>
        </Grid>

        <DetailsGrid
          data={precatorio}
          columns={columns}
          style={{ padding: "8px" }}
        />
      </Grid>
    </Paper>
  );
};

export default PrecatorioArea;
